import { ReplacementsTable } from "modules/AppointmentDetails/components/Interventions/components/Replacements/components";
import { useTyreReplacementUnlinkMutation } from "modules/AppointmentDetails/components/Interventions/components/Replacements/hooks";
import "modules/AppointmentDetails/components/Interventions/components/Replacements/Replacements.scss";

import type { Intervention } from "models";

type ReplacementsProps = {
  intervention: Intervention;
};

export const Replacements = ({ intervention }: ReplacementsProps) => {
  const { mutateAsync: unlinkReplacementMutation } = useTyreReplacementUnlinkMutation();

  if (!intervention.replacements?.length) return null;

  return (
    <div className="Replacements">
      <ReplacementsTable replacements={intervention.replacements} unlinkReplacementMutation={id => unlinkReplacementMutation(id)} />
    </div>
  );
};
